$(document).ready(function(){
  $( "button.view-details" ).each(function( index ) {
    $(this).click(function(){
    var productID = $(this).attr("popupid");
    var producthandle = $(this).attr("prdhandle");
      //alert(productID);
         $('body').addClass("detl-popup-open");
//         $('#popup-'+productID).addClass("open-popup");
      
        jQuery.getJSON('/products/'+producthandle+'.js', function(product) {
          //console.log(product);
          //$("#prd-img img").attr("src",product.images);
          $("h6#prd-title").html(product.title);
          $("div#prd-desc").html(product.description);
          $('form#product-form-installment').attr("data-productid",product.id);
          $('input#prd-id-variant').attr("data-productid",product.id);
          $('.rc-widget-injection-point').html("");
          window.ReChargeWidget.createWidget({ productId: product.id, injectionParent: '.rc-widget-injection-point' });
          var slidepos = 1;
          jQuery.each(product.variants, function(index, item) {
           //console.log(item);
            if( index == 0 ){
              $('input#prd-id-variant').attr("value",item.id);
              var price = (parseFloat(item.price)/100);
              $('span#prd-price').html("£"+price);
            }
          });
          jQuery.each(product.media, function(index, item) {
            //console.log(index);
            if( index == 0 ){
              $("div#prd-img").html('<div class="item active" ><img src="'+item.src+'"></div>');
              $("ol#carousel-indicators").html('<li data-target="#myCarousel" data-slide-to="'+slidepos+'" class="active"></li>');
            }else{
              $("div#prd-img").append('<div class="item" ><img src="'+item.src+'"></div>');
              $("ol#carousel-indicators").append('<li data-target="#myCarousel" data-slide-to="'+slidepos+'"></li>');
            }
            slidepos++;
          });
          
          jQuery.each(product.selling_plan_groups, function(index, item) {
            //console.log(item);
            jQuery.each(item.selling_plans, function(index, item) {
            	if( index == 0 ){
                  //console.log(item.name);
                  //$('select#selling_plan_6947316367567').html('<option data-plan-option="'+item.name+'" value="'+item.id+'" data-v-0c884288="">'+item.name+'</option>');
                	$('option#selling_plan_first').attr("data-plan-option",item.name);
                    $('option#selling_plan_first').attr("value",item.id);
                    $('option#selling_plan_first').html(item.name);                                   
                }else{
                //$('select#selling_plan_6947316367567').append('<option data-plan-option="'+item.name+'" value="'+item.id+'" data-v-0c884288="">'+item.name+'</option>');
                }
            });
            
          });
          
          $.getJSON('/admin/products/' + product.id + '/metafields.json', function(data){
          }).done(function(data) {
             var obj =data.metafields;
            //console.log(data.metafields);
            //console.log(data.metafields[0]['key']);
             for (var prop in obj) {
                 if(data.metafields[prop]['key']=="emoji"){
                  $("ul#prd-tags").html(data.metafields[prop]['value'])
                 }else if(data.metafields[prop]['key']=="product1_handle"){
					var phandle = data.metafields[prop]['value'];
                   //alert(pID);
                   
                   jQuery.getJSON({
                      //type: 'GET',
                      url: '/products/'+phandle+'.js',
                      success: function(response)
                      {
                        $('#first_pord').html('<h6><span>1X</span><br/>'+response.title+'</h6><img src="'+response.images+'">')
                      }
                  });
                 }else if(data.metafields[prop]['key']=="product2_handle"){
					var pID = data.metafields[prop]['value'];
                     var phandle = data.metafields[prop]['value'];
                     
                   	jQuery.getJSON({
                      //type: 'GET',
                      url: '/products/'+phandle+'.js',
                      success: function(response)
                      {
                        $('#second_pord').html('<h6><span>1X</span><br/>'+response.title+'</h6><img src="'+response.images+'">')
                      }
                  });
                 }else if(data.metafields[prop]['key']=="product3_handle"){
					var phandle = data.metafields[prop]['value'];
                   jQuery.getJSON({
                      //type: 'GET',
                      url: '/products/'+phandle+'.js',
                      success: function(response)
                      {
                        $('#third_pord').html('<h6><span>PLUS</span><br/>'+response.title+'</h6><img src="'+response.images+'">')
                      }
                  });
                 }
              }
          });
          if(document.getElementById("header_height")) {
            var headeroffset_height = document.getElementById("header_height").offsetHeight;
            document.getElementById("detail-popup").style.marginTop = headeroffset_height + "px";
          }
          
          $('#detail-popup').addClass("open-popup");
          } );
        } );
    	
  });
   $('span.close').click(function(){
     $('body').removeClass("detl-popup-open");
  	$('div.close-popup').removeClass("open-popup");
   });
//   $('body').click(function() {
//     $('div.close-popup').removeClass("open-popup");
//   })
  $('button.product-form__submit').click(function(){
    $('body').removeClass("detl-popup-open");
  $('div.close-popup').removeClass("open-popup");
  });
  //$("#cart-icon-bubble").click(function(){
  //	$('div#slidecarthq').show();
  //});
  //$('.header button').click(function(){
  //  $('div#slidecarthq').hide();
  //});
  
  $("#shopify-section-template--15080831779023__featured_products .card-wrapper a").click(function(e){
  	e.preventDefault();
    var customer = $(".customer_login").text().trim();
    window.location.href = "/account/login";
    var variant_id = $(this).children(".variant_id").val();
    localStorage.setItem('variantid', variant_id );
  });
  
  $(".header__icon--account").click(function(){
  	localStorage.setItem('variantid', "login" );
  });
  
  var url = window.location.pathname;
  if(url.includes("/account")){
  	var variantid = localStorage.getItem('variantid');
    
 
    	var login_text = $(".customer_login").text();
        if(login_text == "login"){
			 if (variantid !="login" ){
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: variantid
                  },
                    dataType: 'json', 
                   success: function (data) { 
                      window.location.href = '/cart'; 
                   } 
                });
            }
        }

   
  }
  
  const targetNode = document.getElementById("slidecarthq");
  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
          if (mutation.type === 'attributes') {
              // Elements have changed
            console.log("cart toggled", $('#slidecarthq:visible').length);
            $('#slidecarthq .properties-key-value-value:contains("Delivery every")').parents('.main').find('.main-bottom').hide();
          } else {
              //console.log(mutation.type);
          }
      }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});

const AccordionMenu = () => ({
  open: false,

  toggleAccordion() {
    this.open = !this.open
  },
})

const HeaderMain = (params) => ({
  isMenuOpen: false,

  init() {
    this.$nextTick(() => {
      document.documentElement.style.setProperty(
        "--header-height",
        this.$el.offsetHeight + "px"
      )

      if (params.isSticky) {
        this.$el.parentElement?.classList.add("header-main__wrapper--sticky")
      }
    })
  },

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen
    const navElement = document.querySelector(".header-main__nav")
    const body = document.body

    if (navElement) {
      navElement.classList.toggle("header-main__nav--opened", this.isMenuOpen)
      body.classList.toggle("scroll-disabled", this.isMenuOpen)
    }

    if (!this.isMenuOpen) {
      this.closeAllMegamenus()
    }
  },

  closeAllMegamenus() {
    const megamenus = document.querySelectorAll(".megamenu--opened")
    megamenus.forEach((megamenu) =>
      megamenu.classList.remove("megamenu--opened")
    )
    this.$dispatch("close-megamenu")
  },
})

const Megamenu = () => ({
  openMegamenuId: null,
  isMouseOverMenuItem: false,
  isMobileView: window.innerWidth <= 1023,

  init() {
    window.addEventListener("resize", () => {
      this.isMobileView = window.innerWidth <= 1023
    })
  },

  toggleMegamenu(megamenuId) {
    if (this.isMobileView) {
      this.openMegamenuId =
        this.openMegamenuId === megamenuId ? null : megamenuId
    }
  },

  handleHover(megamenuId) {
    if (!this.isMobileView) {
      this.openMegamenuId = megamenuId
      this.isMouseOverMenuItem = true
    }
  },

  handleMouseLeave(megamenuId) {
    if (!this.isMobileView) {
      this.isMouseOverMenuItem = false
      setTimeout(() => {
        if (!this.isMouseOverMenuItem) {
          this.openMegamenuId = null
        }
      }, 100)
    }
  },

  megamenuMouseEnter() {
    this.isMouseOverMenuItem = true
  },

  megamenuMouseLeave() {
    this.isMouseOverMenuItem = false
    this.openMegamenuId = null
  },

  closeMegamenu() {
    this.openMegamenuId = null
    this.$dispatch("close-all-accordions")
  },

  isMegamenuOpen(megamenuId) {
    return this.openMegamenuId === megamenuId
  },
})

document.addEventListener("alpine:init", () => {
  Alpine.data("headerMain", HeaderMain)
  Alpine.data("accordionMenu", AccordionMenu)
  Alpine.data("megamenu", Megamenu)
})

(() => {
    const containers = document.querySelectorAll('.home-feature-slider--collection .add-to-cart-quick__container');

    if (containers.length === 0) {
      return;
    }

    containers.forEach(container => {
      const initialContainer = container.closest('.card-wrapper');

      const handleClassChange = () => {

        if (window.innerWidth > 990) return;

        const isShown = container.classList.contains('add-to-cart-quick__container--show');

        if (isShown) {
          let clone = document.querySelector('.add-to-cart-quick__container-cloned');
          if (!clone) {
            clone = container.cloneNode(true);
            clone.classList.add('add-to-cart-quick__container-cloned');

            const wrapper = document.createElement('div');
            wrapper.classList.add('funkin-product-desc', 'collection');
            wrapper.appendChild(clone);
            document.body.appendChild(wrapper);

            container.classList.add('hidden');

            const closeButton = clone.querySelector('.card__button-add__close');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                const clone = document.querySelector('.add-to-cart-quick__container-cloned');
                if (clone) clone.remove();
                container.classList.remove('hidden');
                const original_button = initialContainer.querySelector('.card__button-add');
                if (original_button) original_button.click();
              });
            }
          }
        } else {
          const clone = document.querySelector('.add-to-cart-quick__container-cloned');
          if (clone) clone.remove();
        }
      };

      const observer = new MutationObserver(() => handleClassChange());
      observer.observe(container, { attributes: true, attributeFilter: ['class'] });
    });
  })();
